import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiHeart, FiStar } from 'react-icons/fi';
import RatingStars from './RatingStars';

const ProductCard = ({ product, formatPrice, getAverageRating, reviews }) => {
  const navigate = useNavigate();
  const avgRating = getAverageRating(product._id);
  const reviewCount = reviews.filter((r) => r.productId === product._id).length;

  // Calculate discount if originalPrice is greater than price
  const discount =
    product.originalPrice > product.price
      ? Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)
      : 0;

  return (
    <div
      className="bg-white border rounded-lg overflow-hidden hover:shadow-md transition-shadow cursor-pointer"
      onClick={() => navigate(`/product/${product._id}`)}
    >
      <div className="relative aspect-square bg-gray-100">
        <img
          src={product.image[0] || '/placeholder-product.jpg'}
          alt={product.name}
          className="w-full h-full object-cover"
          loading="lazy"
        />
        {discount > 0 && (
          <div className="absolute top-2 left-2 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded">
            {discount}% OFF
          </div>
        )}
      </div>
      <div className="p-3">
        <h3 className="font-medium text-sm mb-1 line-clamp-2">{product.name}</h3>

        <div className="flex items-center mb-2">
          <RatingStars rating={avgRating} />
          <span className="text-xs text-gray-500 ml-1">({reviewCount})</span>
        </div>

        <div className="flex items-center justify-between">
          <div>
            <span className="font-bold">{formatPrice(product.price)}</span>
            {product.originalPrice > product.price && (
              <span className="text-xs text-gray-500 line-through ml-1">
                {formatPrice(product.originalPrice)}
              </span>
            )}
          </div>
          <button
            className="p-1 text-gray-500 hover:text-black"
            onClick={(e) => {
              e.stopPropagation();
              // Add to wishlist
            }}
          >
            <FiHeart />
          </button>
        </div>

        {product.colors?.length > 0 && (
          <div className="flex gap-1 mt-2">
            {product.colors.slice(0, 5).map((color) => (
              <div
                key={color}
                className="w-4 h-4 rounded-full border border-gray-200"
                style={{ backgroundColor: color }}
                title={color}
              />
            ))}
            {product.colors.length > 5 && (
              <div className="text-xs text-gray-500">
                +{product.colors.length - 5}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductCard;